import {Grid} from "@mui/material";
import React from "react";

export const DataGridBody = (props) => {
    return <Grid item xs={12} sx={{ height: props.openFilter ? "calc(100% - 200px)" : "calc(100% - 120px)", backgroundColor: "#fcfcfc" }}>{props.children}</Grid>;
}
